"use strict";

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var serialize = require("w3c-xmlserializer");

var DOMException = require("domexception/webidl2js-wrapper");

var utils = require("../generated/utils");

exports.implementation =
/*#__PURE__*/
function () {
  function XMLSerializerImpl(globalObject) {
    _classCallCheck(this, XMLSerializerImpl);

    this._globalObject = globalObject;
  }

  _createClass(XMLSerializerImpl, [{
    key: "serializeToString",
    value: function serializeToString(root) {
      try {
        return serialize(utils.wrapperForImpl(root), {
          requireWellFormed: false
        });
      } catch (e) {
        throw DOMException.create(this._globalObject, [e.message, "InvalidStateError"]);
      }
    }
  }]);

  return XMLSerializerImpl;
}();